import React, {useEffect, useState} from 'react';
import Marquee from "./Marquee";
import './OrderList.css';

const OrderList = ({
  title,
  titleBackgroundColor,
  items,
  columnsCount,
  itemsPerLine,
  itemWidth,
  itemHeight
}) => {

  const [chunkedList, setChunkedList] = useState([]);

  useEffect(() => {
    const result = [];
    for (let i = 0; i < (itemsPerLine * columnsCount); i += itemsPerLine) {
      const slicedArray = items.slice(i, i + itemsPerLine);
      const placeholdersNeeded = Math.max(itemsPerLine - slicedArray.length, 0);
      if (placeholdersNeeded > 0) {
        const placeholderArray = new Array(placeholdersNeeded).fill("");
        result.push(slicedArray.concat(placeholderArray));
      } else {
        result.push(slicedArray);
      }
    }
    setChunkedList(result);
  }, [items, itemsPerLine, columnsCount]);

  return (
      <div className="order-list-container">
        <div className="header"
             style={{backgroundColor: titleBackgroundColor}}>{title}</div>
        <div className="order-multiple-list">
          {chunkedList.map((chunk, chunkIndex) => {
            return (
                <ul className="order-list" key={chunkIndex}>
                  {chunk.map((item, index) => (
                      <li key={index}
                          style={{width: itemWidth, height: itemHeight}}
                          className="list-item"><Marquee text={item} speed={5} /></li>
                  ))}
                </ul>
            );
          })}
        </div>
      </div>
  );
}

export default OrderList;